/**
 * Animates page scrolling to the very top, can be used after navigation
 */
export const scrollToTop = () => {
  window.scrollTo({top: 0, behavior: 'smooth'});
}